import { APP_INITIALIZER, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiModule, BASE_PATH, Configuration, ConfigurationParameters } from '../../openapi';
// used to create fake backend
import { fakeBackendProvider } from './_helpers';
import { AbpModule } from 'abp-ng2-module/dist/src/abp.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { AppComponent } from './app.component';
import { AlertComponent } from './_components';
// import { NgxNavbarModule } from 'ngx-bootstrap-navbar';
import { CollapseModule, } from 'ngx-bootstrap/collapse';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@environments/environment';
import { PlatformLocation, registerLocaleData } from '@angular/common';
import { AppConsts } from '../shared/AppConsts';
import { AppPreBootstrap } from '../AppPreBootstrap';
import * as _ from 'lodash';
import { AccountService } from './_services';
import { LocationFinderService } from './_services/location-finder.service';
import { SharedModule } from "../shared/shared.module";
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { DeviceDetectorService, DeviceType } from 'ngx-device-detector';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { AlertController, IonicModule, Platform } from '@ionic/angular';
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { Router } from '@angular/router';
import { StatusBar } from '@ionic-native/status-bar/ngx';
// import { IonicStorageModule} from '@ionic/storage';
import { Network } from '@ionic-native/network/ngx';
import { NetworkServicesService } from './_services/network-services.service';
import { NoInternetConnectionComponent } from './_components/no-internet-connection/no-internet-connection.component';
import { Globals } from './globals';
import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Market } from "@ionic-native/market/ngx";;
import { Deeplinks } from '@ionic-native/deeplinks/ngx';
import { SafariViewController } from '@ionic-native/safari-view-controller/ngx';
import { LinkExpiredComponent } from './link-expired/link-expired.component';
import { RootedDeviceComponent } from './rooted-device/rooted-device.component'// import { MatButtonModule } from '@angular/material/button';
// import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CamsAuthService } from './_services/cams.auth.service';
import { SSOAuthService } from './_services/sso.service';
import { SslHttpClient } from './_services//ssl.http-client';
import { CookieAuthService } from './_services/cookie-auth.service';
import { StringUtils } from '@shared/utils/StringUtils';;
import { FeePaymentComponent } from './credit-union/fees/fee-payment/fee-payment.component'
// declare var device;
export function appInitializerFactory(injector: Injector,
    platformLocation: PlatformLocation) {
        try {
            return () => {
                // Check if this is a public route and skip authentication
                const url = new URL(window.location.href);
                if (url.pathname.startsWith('/public/')) {
                    console.log('Detected public route, skipping app initialization:', url.pathname);
                    return Promise.resolve(true);
                }
                
                const deviceDetectorService: DeviceDetectorService = injector.get(DeviceDetectorService);
                const alertCtrl: AlertController = injector.get(AlertController);
                let alert: any = null;
                let isMobile: boolean = false;
                const platform: Platform = injector.get(Platform);
                const netwrok: Network = injector.get(Network);
                const ssoAuthService: SSOAuthService = injector.get(SSOAuthService);
                const camsAuthService: CamsAuthService = injector.get(CamsAuthService);
                
                // console.log('is android: ' + platform.is('android'));
                // console.log('is ios: ' + platform.is('ios'));
                // console.log('is mobileweb: ' + !platform.is('mobileweb'));
                // console.log('is mobile: ' + platform.is('mobile'));
                // if (deviceDetectorService.isMobile() && deviceDetectorService.os == 'iOS' ||  deviceDetectorService.os == 'Android') {
                // in case of web chrome(is android: false, is iOS: false, is mobile: true and is mobile web: true)
                // in case of web safari(is android: false, is iOS: false, is mobile: false and is mobile web: false)

                // in case of mobile browser chrome (is android: true, is iOS: false, is mobile: true and is mobile web: true)
                // in case of mobile browser safari (is android: false, is iOS: true, is mobile: true and is mobile web: true)

                // in case of android (is android: true, is ios: false, is mobileweb: false, is mobile: true)
                // in case of iOS (is android: false, is ios: true, is mobileweb: false, is mobile: true)
                // if (deviceDetectorService.isMobile() && deviceDetectorService.os == 'iOS' ||  deviceDetectorService.os == 'Android') {
                if (StringUtils.isMobilePlatform(platform)) {
                    Globals.isMoreRoutingMobileApp = true;
                } else {
                    Globals.isMoreRoutingMobileApp = false;
                }
                if (StringUtils.isMobilePlatform(platform)) {
            
                // if(platform.is('ios') ){
                    console.log('mobile');
                    isMobile = true;
                    Globals.isMobile = true;
                    const netwrok: Network = injector.get(Network);
                    if (netwrok.type != 'none') {
                        abp.ui.setBusy();
                    }
                } else {
                    isMobile = false;
                    Globals.isMobile = false;
                    abp.ui.setBusy();
                }
                return new Promise<boolean>((resolve, reject) => {
                    AppConsts.appBaseHref = getBaseHref(platformLocation);
                    const appBaseUrl = getDocumentOrigin() + AppConsts.appBaseHref;
                    // const appBaseUrl =  AppConsts.appBaseHref;
                    console.log('app base url' + AppConsts.appBaseHref);
                    AppConsts.appBaseUrl = appBaseUrl;
                    // const deviceDetectorService: DeviceDetectorService = injector.get(DeviceDetectorService);
                    // console.log("deviceDetector-", deviceDetectorService)
                    // console.log("deviceDetectorService.isMobile()-", deviceDetectorService.isMobile())
                    // if(deviceDetectorService.isMobile() && window.localStorage.getItem('DeviceOsName')){ //to debug in browser
                    // if (deviceDetectorService.isMobile()) {
                    // if (deviceDetectorService.isMobile() && deviceDetectorService.os == 'iOS' ||  deviceDetectorService.os == 'Android') {
                if (StringUtils.isMobilePlatform(platform)) {
                    // if(platform.is('ios')){
                        console.log('mobile');
                        // const networkService: NetworkServicesService = injector.get(NetworkServicesService);
                   
                        // const alertCtrl: AlertComponent = injector.get(AlertComponent);
                        document.addEventListener('deviceready', () => {
                            const locationFinderService: LocationFinderService = injector.get(LocationFinderService);
                            // var mobres = mobileLocationService.checkGPSPermission();
                            // console.log("window.localStorage.getItem('MobileLocation')-", window.localStorage.getItem('MobileLocation'))
        
                            //setting mobile location on first launch of mobile app
                            if (window.localStorage.getItem('MobileLocation') == null) {
                                // console.log("MobileLocation-if null-");
                                locationFinderService.askToTurnOnGPS().then(
                                    (result) => {
                                        console.log("appmodule-locationFinderService-result-", result);
                                        window.localStorage.removeItem('countryCode');
                                        // bootrapMobile();
                                        intiateSsoMobile();
                                    },
                                    //setting mobile location if user denied to turn on gps or location permission
                                    (err) => {
                                        // console.log("AppModule-", err)
                                        // console.log("AppModule-err=code", err['code'])
                                        // console.log("AppModule-err=msg", err['message'])
        
                                        window.localStorage.setItem('MobileLocation', 'denied')
                                        window.localStorage.removeItem('countryCode')
                                        // bootrapMobile();
                                        intiateSsoMobile();
                                    }
                                );
                            }
                            else {
                                // console.log("MobileLocation-else-");
                                //If mobile location is already set
                                // bootrapMobile();
                                intiateSsoMobile();
                            }
        
                        });
                        // _.unsubscribe()
                    }
                    else {
                        console.log("desktop");
                        AppPreBootstrap.runDesktop(appBaseUrl, () => {
                            abp.event.trigger('abp.dynamicScriptsInitialized');
                            const accountService: AccountService = injector.get(AccountService);
                            // console.log("accountService-", accountService)
                            /* ssoAuthService.initialize().then((ssoResult) => {
                                ssoAuthService.authenticate().then((camsAuth) => {
                                    camsAuthService.authenticate(null).then((camsAuth) => { */
                                    initiateSSO(false).then(() => {
                                        accountService.init().then(
                                            (result) => {
                                                abp.ui.clearBusy();
                    
                                                if (shouldLoadLocale()) {
                                                    const angularLocale = convertAbpLocaleToAngularLocale(abp.localization.currentLanguage.name);
                                                    import(`@angular/common/locales/${angularLocale}.js`)
                                                        .then(module => {
                                                            registerLocaleData(module.default);
                                                            resolve(result);
                                                        }, reject);
                                                } else {
                                                    resolve(result);
                                                }
                                            },
                                            (err) => {
                                                abp.ui.clearBusy();
                                                reject(err);
                                            }
                                        );
                                    });
                                     /* });
                                 });
                            }); */
                        });
                    }

                    function initiateSSO(isMobile: boolean) {
                      return new Promise((resolve, reject) => {
                        const url = new URL(window.location.href);
                        
                        // Skip SSO authentication for public routes
                        if (url.pathname.startsWith('/public/')) {
                          console.log('Skipping SSO authentication for public route:', url.pathname);
                          resolve(true);
                          return;
                        }
                        
                        ssoAuthService.initialize().then((ssoAuthResult) => {
                            // For mobile we need to show `select-country` screen
                            if (isMobile && !(abp.utils.getCookieValue('Wak.Token'))) {
                              resolve(true);
                              return;
                            }
                            
                            if(url.pathname.includes('/join/')) {
                                ssoAuthService.redirectToResetPassword();
                            } else {
                                const code = url.searchParams.get("code");
                                authenticateThroughSSO(code)
                                .then((res) => resolve(res))
                                .catch(reject);
                            }
                        }).catch(reject);
                      })
                    }
      
                    function authenticateThroughSSO(code: string) {
                      return new Promise((resolve, reject) => {
                        ssoAuthService.authenticate(code).then((ssoResult) => {
                          if (!ssoResult) {
                            resolve(null);
                            return;
                          }
                          camsAuthService.authenticate(null).then((camsAuth) => {
                            resolve(camsAuth);
                          }).catch(reject);
                        }).catch(reject);
                      })
                    }
      
                    function intiateSsoMobile() {
                      // TODO: restructure this double runMobile call
                      AppPreBootstrap.runMobile(isMobile, appBaseUrl, netwrok, injector, async () => {
                        const url = new URL(window.location.href);
                        
                        // Skip SSO authentication for public routes
                        if (url.pathname.startsWith('/public/')) {
                          console.log('Skipping mobile SSO authentication for public route:', url.pathname);
                          bootrapMobile();
                          return;
                        }
                        
                        initiateSSO(true).then(() => {
                          bootrapMobile();
                        });
                      });
                    }
        
                    function bootrapMobile() {
                        AppPreBootstrap.runMobile(isMobile, appBaseUrl, netwrok, injector, async () => {
                            abp.event.trigger('abp.dynamicScriptsInitialized');
                            const accountService: AccountService = injector.get(AccountService);
                            console.log("runMobile- call");
                            if (netwrok.type != 'none') {
                                accountService.init().then(
                                    (result) => {
                                        abp.ui.clearBusy();
                                        console.log("runMobile- called init");
                                        if (shouldLoadLocale()) {
                                            const angularLocale = convertAbpLocaleToAngularLocale(abp.localization.currentLanguage.name);
                                            import(`@angular/common/locales/${angularLocale}.js`)
                                                .then(module => {
                                                    registerLocaleData(module.default);
                                                    resolve(result);
                                                }, reject);
                                        } else {
                                            resolve(result);
                                        }

                                    },
                                    (err) => {
                                        abp.ui.clearBusy();
                                        console.log("appmodule-locationFinderService-err-", err)
                                        reject(err);
                                    }
                                );
                            } else {
                                // await this.alert.present();
                                // alert('Please check your network connection');
                                if(alert !=null) {
                                    alert.dismiss();
                                }
                                alert = await alertCtrl.create({
                                    header: '',
                                    backdropDismiss: false,
                                    message: 'Please check your network connection',
                                    // buttons: [
                                    //     {
                                    //         text: 'Retry',
                                    //         role: 'OK',
                                    //         handler: () => {
                                    //             alert.dismiss();
                                    //             window.location.reload();
                                    //             // navigator['app'].exitApp();
                                    //         }
                                    //     }
                                    // ]
                                });
                                await alert.present();
                                abp.ui.clearBusy();
                            }
                            
                        });
                    }
                });
            }; 
        } catch (error) {
            alert('Somthing went wrong. Please check your network connection and retry');
        }
    
}

export function convertAbpLocaleToAngularLocale(locale: string): string {
    if (!AppConsts.localeMappings) {
        return locale;
    }

    const localeMapings = _.filter(AppConsts.localeMappings, { from: locale });
    if (localeMapings && localeMapings.length) {
        return localeMapings[0]['to'];
    }

    return locale;
}

export function shouldLoadLocale(): boolean {
    return abp.localization.currentLanguage.name && abp.localization.currentLanguage.name !== 'en-US';
}

export function getRemoteServiceBaseUrl(): string {
    return AppConsts.remoteServiceBaseUrl;
}

export function getCurrentLanguage(): string {
    if (abp.localization.currentLanguage.name) {
        return abp.localization.currentLanguage.name;
    }

    // todo: Waiting for https://github.com/angular/angular/issues/31465 to be fixed.
    return 'en';
}

export function getBaseHref(platformLocation: PlatformLocation): string {
    const baseUrl = platformLocation.getBaseHrefFromDOM();
    if (baseUrl) {
        return baseUrl;
    }

    return '/';
}

function getDocumentOrigin() {
    if (!document.location.origin) {
        const port = document.location.port ? ':' + document.location.port : '';
        return document.location.protocol + '//' + document.location.hostname + port;
    }

    return document.location.origin;
}

export function apiConfigFactory(): Configuration {
    const params: ConfigurationParameters = {
        // set configuration parameters here.
        basePath: getRemoteServiceBaseUrl()

    }
    // console.log("params-",params)
    return new Configuration(params);
}


@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        IonicModule.forRoot({
            rippleEffect: false,
            mode: 'md',
            animated: true,

        }),
        // IonicStorageModule.forRoot(),
        ApiModule.forRoot(apiConfigFactory),
        AbpModule,
        SharedModule.forRoot(),
        BsDropdownModule.forRoot(),
        AppRoutingModule,
        // NgxNavbarModule,
        CollapseModule.forRoot(),
        BrowserAnimationsModule,
        // MatButtonModule, 
        // MatSnackBarModule, 
        // IonicModule.forRoot()

    ],
    declarations: [
        AppComponent,
        AlertComponent,
        LinkExpiredComponent
,
        RootedDeviceComponent ,
        // FeePaymentComponent  
     ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        // {
        //     provide: BASE_PATH, useValue: JSON.parse(window.localStorage.getItem("apiUrls")) != null ?
        //         JSON.parse(window.localStorage.getItem("apiUrls"))[window.localStorage.getItem('countryCode')] : environment.apiUrl.defaultUrl
        // },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [Injector, PlatformLocation],
            multi: true
        },
        {
            provide: LOCALE_ID,
            useFactory: getCurrentLanguage
        },
        // provider used to create fake backend
        fakeBackendProvider,
        Geolocation,
        NativeGeocoder,
        LocationAccuracy,
        SplashScreen,
        StatusBar,
        Network,
        SmsRetriever,
        NetworkServicesService,
        AppVersion,
        NoInternetConnectionComponent,
        Globals,
        InAppBrowser,
        Market,
        SSOAuthService,
        SslHttpClient,
        CamsAuthService,
        CookieAuthService,
        SafariViewController,
        Deeplinks
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
};